import React, { Component } from 'react';
import * as realGamesService from "../services/realGamesService"
import { deckHerosAdminUrl } from '../configs/const';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'

export default class RealGames extends Component {
    constructor(props) {
        super(props);
        this.state = {
            iframeurl: ""
        };
    }
    componentDidMount() {
        // realGamesService.getToken().then((res) => {
        //     if (res.status === 200) {
        //         let id = res.data.id
        //         // let deckHerosApi = "http://localhost:3000"
        //         let url = deckHerosAdminUrl + "/admin/clients/" + id
        //         // let url =  "http://localhost:3000/admin/clients/" + id
        //         // debugger
        //         this.setState({ url: url })
        //     }
        // })

        realGamesService.realGamesLaunchReport('clients').then((res) => {
            if (!!res && !!res.url) {
                // let id = res.data.id
                // let deckHerosApi = "http://localhost:3000"
                let iframeurl = res.url;//data.url;//deckHerosAdminUrl + "/user/accountstatement/" + id
                // let url = "http://localhost:3000/user/accountstatement/" + id
                this.setState({ iframeurl: iframeurl })
            }
        })
    }
    render() {
        return (
            <div className="bethubs">
                <Header history = {this.props.history} />
                <div className="wrapper">
                    <div className="container-fluid container-padding-0">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="main-box p-0">
                                    <div className="col-center1 markets">
                                        {this.state.url !== "" && < div >
                                            <iframe title={"iframe"} key={"iframe"} style={{ height: "84vh", width: "100%", border: "0px" }} src={this.state.iframeurl}></iframe>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}